/** @jsxImportSource @emotion/react */
import { useState, useEffect } from "react";
import { Message, Button, useTheme } from "basis";
import { useProfile } from "library/hooks/auth/useProfile";
import { getRegional } from "library/getRegional";
import {
  getLocalStorageObject,
  setLocalStorageObject,
} from "library/localStorageUtils";
import { MaxWidthContainer } from "../MaxWidthContainer/MaxWidthContainer";

const LOCAL_STORAGE_KEY = "gem-lat-banner";
const SOME_VALUE = true;

function GemLatBanner() {
  const theme = useTheme();
  const { profile } = useProfile();
  const profileId = profile?.id;
  const isNZ = getRegional("code") === "NZ";
  const [showBanner, setShowBanner] = useState(false);
  const onDismiss = () => {
    setShowBanner(false);

    setLocalStorageObject({
      localStorageKey: LOCAL_STORAGE_KEY,
      objectKey: profileId,
      objectValue: SOME_VALUE,
    });
  };

  useEffect(() => {
    if (profileId) {
      const shouldShow =
        getLocalStorageObject({
          localStorageKey: LOCAL_STORAGE_KEY,
          objectKey: profileId,
        }) !== SOME_VALUE;

      setShowBanner(shouldShow);
    } else {
      setShowBanner(false);
    }
  }, [profileId]);

  if (!isNZ || !showBanner) {
    return null;
  }

  return (
    <div
      css={{
        backgroundColor: theme.colors.secondary.lightBlue.t25,
        padding: `${theme.space[4]} ${theme.space[4]}`,
        [theme.minMediaQueries.xs]: {
          padding: `${theme.space[4]} ${theme.space[10]}`,
        },
      }}
    >
      <MaxWidthContainer>
        <Message
          severity="info-or-minor"
          bg="secondary.lightBlue.t25"
          padding="0"
          callToAction={
            <Button variant="secondary" onClick={onDismiss}>
              Dismiss
            </Button>
          }
        >
          Gem Finance and Latitude are both associated with Latitude Financial
          Services. All references to Latitude products on this website also
          includes Gem Finance products.
        </Message>
      </MaxWidthContainer>
    </div>
  );
}

export { GemLatBanner };
